import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReponseWebService } from 'app/datastruct/Meloyi.module';
import { ServicepoolService } from 'app/services/servicepool.service';

@Component({
  selector: 'app-reimpression-tpv',
  templateUrl: './reimpression-tpv.component.html',
  styleUrls: ['./reimpression-tpv.component.css']
})
export class ReimpressionTpvComponent implements OnInit {

  detailsCommande = [] ;

  retourClientWS  : ReponseWebService ;

  productionId : any ;

  theProduction : any ;
  infosProd : any ;
  autresinfos : any ;
  garanties : any ;
  montantdevis : any ;
  prenom : any ;
  nom : any ;

  partners = [] ;
  partner : any ;
  current = 0 ;
  devisChoosed : any;
  getDateFormatFrench(datebi){
    if(datebi!=undefined){
      let datebiDoug = new Date(datebi) ;
      let weerwi = datebiDoug.toLocaleString('fr-FR', { month: 'long' });
      let jourBi = datebiDoug.getDate() ;
      let anneeBi = datebiDoug.getFullYear() ;
      return jourBi+" "+weerwi+" "+anneeBi ;
    }else
      return "" ;
  }
  getMontantFormatee(montant){
    let resultd = Number(montant).toLocaleString('fr-FR');
    return resultd ;
  }
  getValues(arg){
    return this.devisChoosed.find(item => item.nomvariable === arg)?.valeur ?? 0;
  }
  infoscar
  constructor( private configServer: ServicepoolService, public dialogRef: MatDialogRef<ReimpressionTpvComponent>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any ) {
    this.productionId = data.element ;
    this.souscription = data.souscription;
    this.infoscar = data.infoscar;
    this.devisChoosed = data.devis['allvalues'];
    console.log(data) ;
    console.log("this.devisChoosed ===>> ",this.devisChoosed)
    console.log(this.souscription)
    console.log("The Production ID IS") ;
    console.log(this.productionId) ;
  }
  print(): void {
    if(this.compagnie == 'CNART'){
      document.getElementById('samaTable').style.position = "fixed";
      document.getElementById('samaTable').style.bottom = "8px";
    }
    let printContents, popupWin;
    printContents = document.getElementById("printer").innerHTML;
    popupWin = window.open('', '_blank', 'left=0,top=0,height=800,width=800,innerheight=800,innerwidth=1000');
    popupWin.document.open();
    popupWin.document.write(`
          <html>
              <head>
                  <style>
                      //........Customized style.......
                      
                  </style>
              </head>
              <body onload="window.print();window.close()">${printContents}<br/><h4 style="text-align: center"></h4><br/><br/><hr/><br/><p></body>
          </html>`
    );
    popupWin.document.close();
    
    if(this.compagnie == 'CNART'){
      document.getElementById('samaTable').style.position = "relative";
    }
  }
  dataImpression
  dataToPrint
  operateur

  prenomi;
  nomi;
  profession;
  adresse;
  genre;
  marque;
  type;
  immat;
  police;
  duree;
  dureeEnJour;
  souscription;
  displayDate(date,type){
    if(type == "du"){
      return date.split("T")[0].split("-")[2]+"-"+date.split("T")[0].split("-")[1]+"-"+date.split("T")[0].split("-")[0]
    }else{
      let dd = new Date(date);
      let f = dd.setDate(dd.getDate()+parseInt(this.dureeEnJour));
      let ddd = ((new Date(f)).toJSON()).split("T",2)[0];
      return ddd.split("T")[0].split("-")[2]+"-"+ddd.split("T")[0].split("-")[1]+"-"+ddd.split("T")[0].split("-")[0]
    }

  }
compagnie = "";
ngOnInit(): void {
  this.dataToPrint = this.productionId
  console.log("========> ",this.dataToPrint);
  console.log("this.devisChoosed ===>> ",this.devisChoosed)
  
  this.prenom = JSON.parse(this.dataToPrint.nomAssure).prenom+" "+JSON.parse(this.dataToPrint.nomAssure).nom;
  this.profession = "";
  this.adresse = "";
  this.compagnie = JSON.parse(this.dataToPrint.infoSup).compagnie
  this.genre = this.dataToPrint.genre;
  this.marque = this.infoscar.Marque;
  this.type = this.infoscar.Appelation;
  this.immat = this.dataToPrint.immatricule;
  this.police = this.souscription.refPolice;
  this.duree = this.dataToPrint.dateEffet.split(" ")[0];
  this.dureeEnJour = this.dataToPrint.dateEcheance.split(" ")[0];
    
    this.operateur = JSON.parse(sessionStorage.getItem('currentUser'));
    console.log("compagnie ",this.compagnie)
  }
  annuler(){
    this.dialogRef.close() ;
  }
  getDetailProdLine(idprod){
    this.configServer.getDetailProdLine(idprod).then( (retourbi) => {

      this.retourClientWS = retourbi ;
      var statutrec = this.retourClientWS.statutreq ;
      //console.log(this.retourClientWS)
      if(statutrec==1){
          this.theProduction = this.retourClientWS.data[0] ;
        //console.log(this.theProduction)
        this.infosProd = JSON.parse(this.theProduction.infos) ;
        this.autresinfos = JSON.parse(this.theProduction.autresinfos) ;
        this.garanties = JSON.parse(this.theProduction.garanties) ;
        this.montantdevis = this.theProduction.montantdevis ;
        this.prenom = this.theProduction.prenom ;
        this.nom = this.theProduction.nom ;
          console.log(this.theProduction.infos) ;
        }
        else
          console.log("Failed") ;
    }) ;
  }
}
